module.exports = __webpack_public_path__ + "f9b7cf175700d18af9d48eaaf3ba40c2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/salesApp/error-icon.svg
// module id = zW7R
// module chunks = 458